<template>
  <v-container>
    <v-dialog v-model="addLeaveDialog" max-width="750px">
      <template v-slot:activator="{ on }">
        <v-row>
          <v-col>
            <v-btn right color="primary" dark class="mb-2" v-on="on" @click="addedItem()">{{$t('add_category')}}</v-btn>
          </v-col>
          <!-- <v-col md="6" class="pt-0">
            <v-text-field hide-details label="Find Leave Code" :rules="[validator.alfaNumberNotRequired]"
              prepend-inner-icon="mdi-magnify" single-line v-model="search"></v-text-field>
          </v-col> -->
        </v-row>
      </template>
      <v-form v-model="valid" ref="addForm">
        <v-card class="pt-3">
          <v-card-title>
            <span class="headline ml-2 text-capitalize">{{$t('add leave category')}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col sm="12">
                  <v-text-field label="Set Leave Name"  :rules="[rulesMax50, validator.alfaNumberNotRequired]"
                    counter="50" v-model="addItem.leave_name_in" required class="sae-required"
                    type="text"></v-text-field>
                </v-col>
                <v-col sm="12">
                  <v-autocomplete v-model="addItem.leave_category" :items="groupList" hide-no-data required
                    class="sae-required" item-text="alias" item-value="id" :rules="[...rules]"
                    label="Select Leave Type"></v-autocomplete>
                </v-col>
                <v-col sm="12" class="mb-n4" style="font-size: 1rem;">
                  <div>Leave Limit per year (Days)</div>
                </v-col>
                <v-col sm="6">

                  <v-switch class="label-12" inset
                    :label="addCategory.limit_balance_1 > 0  ? `Leave amount per year is limited` : `Leave amount per year is not limited`"
                    v-model="switchAdd1" @change="switchAddChange1">
                  </v-switch>
                </v-col>
                <v-col sm="6">
                  <v-text-field class="centered-input" v-model="noneOrValue" readonly>
                    <v-icon @click="addCategory.limit_balance_1++" :disabled="addCategory.limit_balance_1 < 1"
                      :style="addCategory.limit_balance_1 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                      style="border-radius: 2px;" slot="append-outer" color="#FFFFFF">
                      mdi-plus
                    </v-icon>
                    <v-icon @click="--addCategory.limit_balance_1" :disabled="addCategory.limit_balance_1 < 1"
                      :style="addCategory.limit_balance_1 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                      style="border-radius: 2px;" slot="prepend" color="#FFFFFF">
                      mdi-minus
                    </v-icon>
                  </v-text-field>
                </v-col>
                <v-col sm="12" class="mb-n4 sae-required-div" style="font-size: 1rem;">
                  <div>Leave Amount per Taken (Days)</div>
                </v-col>
                <v-col sm="6">

                  <v-switch class="label-12" inset
                    :label="addCategory.limit_balance_2 > 0  ? `The amount per taken is strictly set` : `The amount per taken is not strictly set`"
                    v-model="switchAdd2" @change="switchAddChange2">
                  </v-switch>
                </v-col>
                <v-col sm="6">
                  <v-text-field class="centered-input" v-model="requestOrNone" readonly>
                    <v-icon @click="addCategory.limit_balance_2++" :disabled="addCategory.limit_balance_2 < 1"
                      :style="addCategory.limit_balance_2 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                      style="border-radius: 2px;" slot="append-outer" color="#FFFFFF">
                      mdi-plus
                    </v-icon>
                    <v-icon @click="--addCategory.limit_balance_2" :disabled="addCategory.limit_balance_2 < 1"
                      :style="addCategory.limit_balance_2 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                      style="border-radius: 2px;" slot="prepend" color="#FFFFFF">
                      mdi-minus
                    </v-icon>
                  </v-text-field>

                </v-col>
                <v-col sm="12" class="mt-n6">
                  <span style="font-size: 12px; color: #1976D2;">{{noteForBoth}}</span>
                </v-col>

                <v-col sm="12">
                  <v-label class="fs-14">
                      Carry Over / Reset
                  </v-label>
                </v-col>

                <v-col sm="12">
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select
                        :items="[
                          { name: 'Carry Over', value: true },
                          { name: 'Reset', value: false },
                        ]"
                        item-text="name"
                        item-value="value"
                        variant="underlined"
                        color="blue"
                        :rules="[...rules]"
                        v-model="addItem.carrying_over"
                        >
                      </v-select>
                    </v-col>
              
                    <v-col cols="12" md="4">
                      <v-select
                        v-if="addItem.carrying_over"
                        :items="[
                          { name: 'Maximum Amount', value: 0 },
                          { name: 'Custom Percentage', value: 1 },
                          { name: 'Full', value: 2 },
                        ]"
                        item-text="name"
                        item-value="value"
                        variant="underlined"
                        :rules="[...rules]"
                        color="blue"
                        v-model="carrying_over_type"
                        >
                      </v-select>

                      <v-text-field
                        v-else
                        color="blue"
                        type="number"
                        variant="underlined"
                        value="-"
                        disabled
                        >
                      </v-text-field>
                    </v-col>
              
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-if="carrying_over_type !== 2 && addItem.carrying_over"
                        color="blue"
                        type="number"
                        variant="underlined"
                        :rules="[...rules]"
                        :suffix="carrying_over_type === 1 ? '%' : ''"
                        v-model.number="addItem.carrying_over_amount"
                        >
                      </v-text-field>

                      <v-text-field
                        v-else
                        color="blue"
                        type="number"
                        variant="underlined"
                        value="-"
                        disabled
                        >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col sm="12">
                  <v-select
                    :items="[
                      { name: 'Join Date', value: 0 },
                      { name: 'End of Year', value: 1 }
                    ]"
                    item-text="name"
                    item-value="value"
                    variant="underlined"
                    color="blue"
                    required
                    class="sae-required"
                    label="Carry Over / Reset Annual Date"
                    :rules="[...rules]"
                    v-model="addItem.reset_by"
                    >
                  </v-select>
                </v-col>

                <!-- <v-col>
                  <v-select
                    :items="[
                      { name: 'Allowed', value: true },
                      { name: 'Not Allowed', value: false },
                    ]"
                    item-text="name"
                    item-value="value"
                    variant="underlined"
                    color="blue"
                    required
                    class="sae-required"
                    label="Allow Half Day Leave"
                    :rules="[...rules]"
                    v-model="addItem.allow_half_day"
                    >
                  </v-select>
                </v-col> -->

                <v-col sm="12" class="">
                  <v-autocomplete v-model="addItem.period" :items="periodList" hide-no-data item-text="alias"
                    item-value="id" :rules="[...rules]" required class="sae-required"
                    label="Minimum Working Period Requirement"></v-autocomplete>
                </v-col>
                <v-col sm="12">
                  <v-autocomplete v-model="addItem.is_attachment" :items="is_attachment" hide-no-data item-text="name"
                    item-value="id" required class="sae-required" :label="$t('attachment')">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-select :items="appType" :label="$t('approval_type')" :rules="rules" v-model="addItem.approval_type"
                    item-text="name" item-value="id"></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="mx-6 pb-6">
            <v-row justify="center">
              <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
              <v-btn :loading="loading" color="primary" @click="addLeave(addItem)" :disabled="!valid">
                {{$t('save')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="editLeaveDialog" max-width="750px">
      <v-card class="pt-3">
        <v-card-title>
          <span class="headline ml-2 text-capitalize">{{$t('edit leave category')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col sm="12">
                <v-text-field label="Set Leave Name" v-model="editItem.leave_name_in" required class="sae-required"
                  type="text"></v-text-field>
              </v-col>
              <v-col sm="12">
                <v-autocomplete v-model="editItem.leave_category" :items="groupList" hide-no-data required
                  class="sae-required" item-text="alias" item-value="id" :rules="[...rules]" label="Select Leave Type">
                </v-autocomplete>
              </v-col>
              <v-col sm="12" class="mb-n4" style="font-size: 1rem;">
                <div>Leave Limit per year (Days)</div>
              </v-col>
              <v-col sm="6">

                <v-switch class="label-12" inset
                  :label="editCategory.limit_balance_1 > 0  ? `Leave amount per year is limited` : `Leave amount per year is not limited`"
                  v-model="switchEdit1" @change="switchEditChange1">
                </v-switch>
              </v-col>
              <v-col sm="6">
                <v-text-field class="centered-input" v-model="noneOrValueEdit" readonly>
                  <v-icon @click="editCategory.limit_balance_1++" :disabled="editCategory.limit_balance_1 < 1"
                    :style="editCategory.limit_balance_1 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                    style="border-radius: 2px;" slot="append-outer" color="#FFFFFF">
                    mdi-plus
                  </v-icon>
                  <v-icon @click="--editCategory.limit_balance_1" :disabled="editCategory.limit_balance_1 < 1"
                    :style="editCategory.limit_balance_1 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                    style="border-radius: 2px;" slot="prepend" color="#FFFFFF">
                    mdi-minus
                  </v-icon>
                </v-text-field>
              </v-col>
              <v-col sm="12" class="mb-n4 sae-required-div" style="font-size: 1rem;">
                <div>Leave Amount per Taken (Days)</div>
              </v-col>
              <v-col sm="6">

                <v-switch class="label-12" inset
                  :label="editCategory.limit_balance_2 > 0  ? `The amount per taken is strictly set` : `The amount per taken is not strictly set`"
                  v-model="switchEdit2" @change="switchEditChange2">
                </v-switch>
              </v-col>
              <v-col sm="6">
                <v-text-field class="centered-input" v-model="requestOrNoneEdit" readonly>
                  <v-icon @click="editCategory.limit_balance_2++" :disabled="editCategory.limit_balance_2 < 1"
                    :style="editCategory.limit_balance_2 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                    style="border-radius: 2px;" slot="append-outer" color="#FFFFFF">
                    mdi-plus
                  </v-icon>
                  <v-icon @click="--editCategory.limit_balance_2" :disabled="editCategory.limit_balance_2 < 1"
                    :style="editCategory.limit_balance_2 < 1 ? `background: #E6E6E6;` : `background: #1976D2;`"
                    style="border-radius: 2px;" slot="prepend" color="#FFFFFF">
                    mdi-minus
                  </v-icon>
                </v-text-field>

              </v-col>
              <v-col sm="12" class="mt-n6">
                <span style="font-size: 12px; color: #1976D2;">{{noteForBothEdit}}</span>
              </v-col>

              <v-col sm="12">
                <v-label class="fs-14">
                    Carry Over / Reset
                </v-label>
              </v-col>

              <v-col sm="12">
                <v-row>
                  <v-col cols="12" md="4">
                    <v-select
                      :items="[
                        { name: 'Carry Over', value: true },
                        { name: 'Reset', value: false },
                      ]"
                      item-text="name"
                      item-value="value"
                      variant="underlined"
                      color="blue"
                      :rules="[...rules]"
                      v-model="editItem.carrying_over"
                      >
                    </v-select>
                  </v-col>
            
                  <v-col cols="12" md="4">
                    <v-select
                      v-if="editItem.carrying_over"
                      :items="[
                        { name: 'Maximum Amount', value: 0 },
                        { name: 'Custom Percentage', value: 1 },
                        { name: 'Full', value: 2 },
                      ]"
                      item-text="name"
                      item-value="value"
                      variant="underlined"
                      :rules="[...rules]"
                      color="blue"
                      v-model="carrying_over_type"
                      >
                    </v-select>

                    <v-text-field
                      v-else
                      color="blue"
                      type="number"
                      variant="underlined"
                      value="-"
                      disabled
                      >
                    </v-text-field>
                  </v-col>
            
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-if="carrying_over_type !== 2 && editItem.carrying_over"
                      color="blue"
                      type="number"
                      variant="underlined"
                      :rules="[...rules]"
                      :suffix="carrying_over_type === 1 ? '%' : ''"
                      v-model.number="editItem.carrying_over_amount"
                      >
                    </v-text-field>

                    <v-text-field
                      v-else
                      color="blue"
                      type="number"
                      variant="underlined"
                      value="-"
                      disabled
                      >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>

              <v-col sm="12">
                <v-select
                  :items="[
                    { name: 'Join Date', value: 0 },
                    { name: 'End of Year', value: 1 }
                  ]"
                  item-text="name"
                  item-value="value"
                  variant="underlined"
                  color="blue"
                  required
                  class="sae-required"
                  label="Carry Over / Reset Annual Date"
                  :rules="[...rules]"
                  v-model="editItem.reset_by"
                  >
                </v-select>
              </v-col>

              <!-- <v-col>
                <v-select
                  :items="[
                    { name: 'Allowed', value: true },
                    { name: 'Not Allowed', value: false },
                  ]"
                  item-text="name"
                  item-value="value"
                  variant="underlined"
                  color="blue"
                  required
                  class="sae-required"
                  label="Allow Half Day Leave"
                  :rules="[...rules]"
                  v-model="editItem.allow_half_day"
                  >
                </v-select>
              </v-col> -->

              <v-col sm="12" class="">
                <v-autocomplete v-model="editItem.period" :items="periodList" hide-no-data item-text="alias"
                  item-value="id" :rules="[...rules]" required class="sae-required"
                  label="Minimum Working Period Requirement"></v-autocomplete>
              </v-col>
              <v-col sm="12">
                <v-autocomplete v-model="editItem.is_attachment" :items="is_attachment" hide-no-data item-text="name"
                  item-value="id" required class="sae-required" :rules="[...rules]" :label="$t('attachment')">
                </v-autocomplete>
              </v-col>
              <v-col cols="12">
                  <v-select :items="appType" :label="$t('approval_type')" :rules="rules" v-model="editItem.approval_type"
                    item-text="name" item-value="id"></v-select>
                </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="mx-6 pb-6">
          <v-row justify="center">
            <v-btn color="primary" text @click="close">{{$t('cancel')}}</v-btn>
            <v-btn :loading="loading" color="primary" @click="editLeave(editItem)">
              {{$t('save')}}</v-btn>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteLeaveDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{$t('delete_category')}}</v-card-title>
        <v-card-text>{{$t('you_sure')}}</v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deleteLeaveDialog = false">{{$t('cancel')}}</v-btn>
          <v-btn color="error" @click="deleteLeave(itemToDelete.id)">{{$t('delete')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table :sort-desc="true" :items="leave_category" :items-per-page="pageSize" :server-items-length="totalData"
      :page="page" @update:page="getLeaveCategory($event, pageSize)"
      @update:items-per-page="getLeaveCategory(page, $event)" :headers="headers" :search="search"
      class="elevation-1 mt-3" no-data-text="Empty list. Please add leave category"
      :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }">
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" color="primary" @click="editedItem(item)">mdi-pencil</v-icon>
        <v-icon small color="error" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>
      <template v-slot:item.limit_balance="{ item }">
        <div v-if="item.limit_balance > 0">{{item.limit_balance}}</div>
        <div v-else>None</div>
      </template>
      <template v-slot:item.amount_taken="{ item }">
        <div v-if="item.amount_taken > 0">{{item.amount_taken}}</div>
        <div v-else>As Requested</div>
      </template>
      <template v-slot:item.working_period_requirement="{ item }">
        <div v-if="item.working_period_requirement > 0"> {{workingPeriod(item.working_period_requirement)}}</div>
        <div v-else>None</div>
      </template>
      <template v-slot:item.is_attachment="{ item }">
        <div v-if="item.is_attachment == true">{{$t('mandatory')}}</div>
        <div v-else>{{$t('not_mandatory')}}</div>
      </template>
      <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}}
        {{ items.itemsLength }} </template>
    </v-data-table>
  </v-container>
</template>

<script>
  import moment from "moment";
  export default {
    name: "leave",
    data() {
      return {
        headers: [{
            text: "Leave Type",
            value: "leave_category",
            sortable: false
          },
          {
            text: 'Leave Name',
            value: "leave_name_in",
            sortable: false
          },
          {
            text: 'Leave Limit per Year (days)',
            value: "limit_balance",
            align: 'center',
            sortable: false
          },
          // { text: "Remark Indonesia", value: "remark_in" },
          {
            text: 'Leave Amount per Taken (days)',
            value: "amount_taken",
            align: 'center',
            sortable: false
          },
          {
            text: 'Minimum Working Period Requirement',
            value: "working_period_requirement",
            align: 'center',
            sortable: false
          },
          { text: this.$i18n.t('approval_type'), value: "approval_type",  align: 'center',
            sortable: false },
          // { text: this.$i18n.t('deductible'), value: "is_balance_deduction" },
          {
            text: this.$i18n.t('manage'),
            value: "action",
            sortable: false
          },
        ],
        appType: [{
            name: this.$i18n.t('1_layer'),
            id: 1,
          },
          {
            name: this.$i18n.t('2_layer'),
            id: 2,
          }
        ],
        today: moment().format('YYYY-MM-DD'),
        addCategory: {
          limit_balance_1: 0,
          limit_balance_2: 1,
        },
        editCategory: {
          limit_balance_1: 0,
          limit_balance_2: 1,
        },
        // switchAdd1: false,
        // switchAdd2: false,
        dummyData: [{
            leave_category: 'Annual Leave',
            leave_code: 'Cuti Tahunan',
            amount_taken: 1,
            limit: 12,
            period: '>1 Year'
          },
          {
            leave_category: 'Annual Leave',
            leave_code: 'Cuti Tahunan',
            amount_taken: 1,
            limit: 12,
            period: '>1 Year'
          },
          {
            leave_category: 'Annual Leave',
            leave_code: 'Cuti Tahunan',
            amount_taken: 1,
            limit: 12,
            period: '>1 Year'
          },
          {
            leave_category: 'Annual Leave',
            leave_code: 'Cuti Tahunan',
            amount_taken: 1,
            limit: 12,
            period: '>1 Year'
          }
        ],
        company_id: this.$store.state.company,
        validator: this.$store.state.validator,
        valid: true,
        baseUrl: this.$store.state.baseUrl,
        leave_list: [],
        search: "",
        carrying_over_type: 0,
        addItem: {
          leave_code: "",
          leave_name_in: "",
          amount_taken: "",
          limit: "",
          period: "",
          approval_type: "",
          is_attachment: false,
          carrying_over: false,
          carrying_over_type: undefined,
          carrying_over_amount: undefined,
          reset_by: 0,
          allow_half_day: false,
        },
        editItem: {
          category: "",
          code: "",
          amount: "",
          limit: "",
          period: "",
          approval_type: "",
          is_attachment: false,
          carrying_over: false,
          carrying_over_type: undefined,
          carrying_over_amount: undefined,
          reset_by: 0,
          allow_half_day: false,
        },
        itemToDelete: {
          id: "",
          companyId: "",
        },
        leave: [{
          id: "",
          companyId: "",
        }],
        is_attachment: [{
            name: this.$i18n.t('mandatory'),
            id: true,
          },
          {
            name: this.$i18n.t('not_mandatory'),
            id: false,
          }
        ],
        addLeaveDialog: false,
        deleteLeaveDialog: false,
        editLeaveDialog: false,
        loading: false,
        editedIndex: -1,
        totalData: 0,
        page: 1,
        pageSize: 10,
        leave_code: ["L-1", "L-2", "L-3", "L-4", "L-5", ],
        rules: [(value) => (value == 0 ? true : !!value || this.$i18n.t('required'))],
        rulesWithSpace: [v => /^[a-zA-Z0-9 ]+$/.test(v) || this.$i18n.t('accept_only_alfanumberic')],
        rulesMax10: v => (v && v.length <= 10) || `${this.$i18n.t('max_char')} 10`,
        rulesMax50: v => (v && v.length <= 50) || `${this.$i18n.t('max_char')} 50`,
        groupList: ["Annual Leave", "Sick Leave", "Big Leave", "Maternity Leave", "Special Leave"],
        amountList: ["0 - Limit", "As Requested"],
        limitList: ["None (-)", "1 - 60"],
        periodList: ["None", "> 1 Year", "> 2 Years", "> 3 Years", "> 4 Years", "> 5 Years", "> 6 Years", "> 7 Years",
          "> 8 Years", "> 9 Years", "> 10 Years",
        ],
        attachmentList: ["Not Mandatory", "Mandatory"],
        searchgroups: "",
        leave_category: []
      };
    },
    computed: {
      switchAdd1() {
        return this.addCategory.limit_balance_1 > 0 ? true : false;
      },
      switchAdd2() {
        return this.addCategory.limit_balance_2 > 0 ? true : false;
      },
      noneOrValue() {
        if (this.addCategory.limit_balance_1 < 1) {
          return 'None'
        } else {
          return this.addCategory.limit_balance_1
        }
      },
      requestOrNone() {
        if (this.addCategory.limit_balance_2 < 1) {
          return 'As Requested'
        } else {
          return this.addCategory.limit_balance_2
        }
      },
      noteForBoth() {
        if (this.addCategory.limit_balance_1 > 0 && this.addCategory.limit_balance_2 > 0) {
          return 'Note : When leave amount per year is limited, The amount per taken is not bigger than its limit.'
        } else {
          return ""
        }
      },
      switchEdit1() {
        return this.editCategory.limit_balance_1 > 0 ? true : false;
      },
      switchEdit2() {
        return this.editCategory.limit_balance_2 > 0 ? true : false;
      },
      noneOrValueEdit() {
        if (this.editCategory.limit_balance_1 < 1) {
          return 'None'
        } else {
          return this.editCategory.limit_balance_1
        }
      },
      requestOrNoneEdit() {
        if (this.editCategory.limit_balance_2 < 1) {
          return 'As Requested'
        } else {
          return this.editCategory.limit_balance_2
        }
      },
      noteForBothEdit() {
        if (this.editCategory.limit_balance_1 > 0 && this.editCategory.limit_balance_2 > 0) {
          return 'Note : When leave amount per year is limited, The amount per taken is not bigger than its limit.'
        } else {
          return ""
        }
      }
    },
    methods: {
      showMessage(type, msg) {
        this.$store.dispatch('nShowMessage', {
          type,
          msg
        })
      },
      switchAddChange1() {
        if (this.addCategory.limit_balance_1 > 0) {
          this.addCategory.limit_balance_1 = 0
          this.switchAdd1 = false
        } else {
          this.addCategory.limit_balance_1 = 1
          this.switchAdd1 = true
        }
      },
      switchAddChange2() {
        if (this.addCategory.limit_balance_2 > 0) {
          this.addCategory.limit_balance_2 = 0
          this.switchAdd2 = false
        } else {
          this.addCategory.limit_balance_2 = 1
          this.switchAdd2 = true
        }
      },
      switchEditChange1() {
        if (this.editCategory.limit_balance_1 > 0) {
          this.editCategory.limit_balance_1 = 0
          this.switchEdit1 = false
        } else {
          this.editCategory.limit_balance_1 = 1
          this.switchEdit1 = true
        }
      },
      switchEditChange2() {
        if (this.editCategory.limit_balance_2 > 0) {
          this.editCategory.limit_balance_2 = 0
          this.switchEdit2 = false
        } else {
          this.editCategory.limit_balance_2 = 1
          this.switchEdit2 = true
        }
      },
      async getLeaveCategory(page = 1, pageSize = 10) {
        this.page = page;
        this.pageSize = pageSize;
        const result = await this.$store.dispatch('getLCategory', {
          companyId: this.company_id,
          page: page,
          pageSize: pageSize
        })
        this.leave_category = result.records;
        this.totalData = result.total;
      },
      workingPeriod(period) {
        const totalPeriod = Math.round(period / 12)
        if (totalPeriod === 1) {
          return "> " + totalPeriod + " Year"
        } else if (totalPeriod > 1) {
          return "> " + totalPeriod + " Years"
        } else {
          return "None"
        }
      },
      addedItem() {
        this.carrying_over_type = 0;
        this.addLeaveDialog = true;
      },
      editedItem(item) {
        // eslint-disable-next-line no-console
        // console.log(item);
        this.editedIndex = this.leave.indexOf(item);
        this.editItem = Object.assign({}, item);
        this.editCategory.limit_balance_1 = item.limit_balance
        this.editCategory.limit_balance_2 = item.amount_taken
        this.editItem.period = this.workingPeriod(item.working_period_requirement)
        this.carrying_over_type = item.carrying_over_type
        this.editLeaveDialog = true;
      },
      deleteItem(item) {
        this.itemToDelete = Object.assign({}, item);
        this.deleteLeaveDialog = true;
      },
      close() {
        this.addLeaveDialog = false;
        this.editLeaveDialog = false;
        this.deleteLeaveDialog = false;
        this.carrying_over_type = 0;
      },
      async getLeaveCategoryList() {
        this.leave_list = await this.$store.dispatch('getLeaveCategory', {
          companyId: this.company_id
        })
      },
      async addLeave(item) {
        this.loading = true;
        const result = await this.$store.dispatch('newSaveLeaveCategory', {
          date: this.today,
          companyId: this.company_id,
          working_period_requirement: this.periodList.indexOf(item.period) * 12,
          amount_taken: this.addCategory.limit_balance_2,
          leave_category: item.leave_category,
          limit_balance: this.addCategory.limit_balance_1,
          leave_code: this.leave_code[this.groupList.indexOf(item.leave_category)],
          is_attachment: item.is_attachment,
          leave_category_en: item.leave_name_in,
          leave_category_in: item.leave_name_in,
          leave_name_in: item.leave_name_in,
          approval_type: item.approval_type,
          carrying_over: item.carrying_over,
          carrying_over_type: item.carrying_over_type,
          carrying_over_amount: item.carrying_over_amount,
          reset_by: item.reset_by,
          allow_half_day: item.allow_half_day,
        })
        this.loading = false;
        if (result) {
          this.addLeaveDialog = false;
          this.getLeaveCategory();
          this.showMessage('success', this.$i18n.t('alert_save'))
        } else {
          this.addLeaveDialog = true;
          this.loading = false;
        }
      },
      async editLeave(item) {
        this.loading = true;
        const result = await this.$store.dispatch('editNewLeaveCategory', {
          id: item.id,
          working_period_requirement: this.periodList.indexOf(item.period) * 12,
          amount_taken: this.editCategory.limit_balance_2,
          leave_category: item.leave_category,
          limit_balance: this.editCategory.limit_balance_1,
          is_attachment: item.is_attachment,
          leave_category_en: item.leave_name_in,
          leave_category_in: item.leave_name_in,
          leave_name_in: item.leave_name_in,
          approval_type: item.approval_type,
          carrying_over: item.carrying_over,
          carrying_over_type: item.carrying_over_type,
          carrying_over_amount: item.carrying_over_amount,
          reset_by: item.reset_by,
          allow_half_day: item.allow_half_day,
        })
        this.loading = false;
        if (result) {
          this.loading = false;
          this.editLeaveDialog = false;
          this.showMessage('success', this.$i18n.t('alert_save'))
          this.getLeaveCategory(this.page, this.pageSize);
        } else {
          this.editLeaveDialog = true;
        }
      },
      async deleteLeave(id) {
        const result = await this.$store.dispatch('deleteNewLeaveCategory', {
          id: id
        })
        if (result) {
          this.deleteLeaveDialog = false;
          this.showMessage('success', this.$i18n.t('alert_delete'))
          this.getLeaveCategory();
        }
      }
    },
    created() {
      this.getLeaveCategory();
    },
    watch: {
      dialog() {
        this.changeNUserStatus(this.editedItem.status);
        this.changeUserRole(this.editedItem.role);
      },
      'addItem.carrying_over'(newVal) {
        if (!newVal) {
          this.addItem.carrying_over_type = undefined;
          this.addItem.carrying_over_amount = undefined;
        } else {
          this.addItem.carrying_over_type = 0;
          this.addItem.carrying_over_amount = 1;
        }
      },
      'addItem.carrying_over_amount'(newVal) {
        if (newVal) {
          if (newVal < 1) {
            this.addItem.carrying_over_amount = 1;
          }
          if (this.addItem.carrying_over_type === 1) {
            if (newVal > 100) {
              this.addItem.carrying_over_amount = 100;
            }
          }
        }
      },
      'editItem.carrying_over'(newVal) {
        if (!newVal) {
          this.editItem.carrying_over_type = undefined;
          this.editItem.carrying_over_amount = undefined;
        } else {
          this.editItem.carrying_over_type = this.editItem.carrying_over_type;
          this.editItem.carrying_over_amount = this.editItem.carrying_over_amount;
        }
      },
      'editItem.carrying_over_amount'(newVal) {
        if (newVal) {
          if (newVal < 1) {
            this.editItem.carrying_over_amount = 1;
          }
          if (this.editItem.carrying_over_type === 1) {
            if (newVal > 100) {
              this.editItem.carrying_over_amount = 100;
            }
          }
        }
      },
      carrying_over_type(newVal) {
        // console.log(newVal)
        if (newVal === 0) {
          this.addItem.carrying_over_type = newVal;
          this.addItem.carrying_over_amount = 1;
          this.editItem.carrying_over_type = newVal;
          this.editItem.carrying_over_amount = 1;
        } else {
          if (newVal === 2) {
            this.addItem.carrying_over_amount = 100;
            this.editItem.carrying_over_amount = 100;
            this.addItem.carrying_over_type = 2;
            this.editItem.carrying_over_type = 2;
          } else {
            this.addItem.carrying_over_type = 1;
            this.editItem.carrying_over_type = 1;
            this.addItem.carrying_over_amount = 1;
            this.editItem.carrying_over_amount = 1;
          }
        
        }
      },
      addLeaveDialog() {
        if (this.$refs.addForm) {
          this.addCategory.limit_balance_1 = 0;
          this.addCategory.limit_balance_2 = 1;
          this.addItem.leave_code = "";
          this.addItem.leave_name_in = "";
          this.addItem.amount_taken = "";
          this.addItem.limit = "";
          this.addItem.period = "";
          this.addItem.is_attachment = "";
          this.addItem.approval_type = "";
          this.leave_category = "";
          this.carrying_over  = false;
          this.carrying_over_type = undefined;
          this.carrying_over_amount = undefined;
          this.reset_by = 0;
          this.allow_half_day = false;
        }
      },
    },
  };
</script>
<style scoped>
  .v-progress-circular {
    margin: 1rem;
  }

  .centered-input>>>input {
    text-align: center
  }
</style>